import { EstadosProcesoEnumChoice, gridSize, gridSizeMdLg3, gridSizeMdLg4, newRecepcionCompraSchema, ROUTER_PATHS, texto, useCheckPermissionsArray, useUploadFile } from "@/shared";
import { CustomTextField, SingleButton } from "@/shared/components/ui";
import { Grid, Typography } from "@mui/material";
import RuleRoundedIcon from '@mui/icons-material/RuleRounded';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import { useLocation, useNavigate, /* useParams */ } from "react-router-dom";
import { SaveRecepcionCompraFormData } from "@/shared/interfaces/erp/compras/recepcion-compra.interface";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import CustomTextFielRead from "@/shared/components/ui/CustomTextFielRead";
import { BODEGAS, TiposBodegaEnum, TipoUbicacionEnum, Ubicaciones } from "@/shared/interfaces/erp/inventario";
import { useCreateIngresoProducto, useFetchBodegas, useFetchUbicaciones, useUpdateOrdenesCompra, } from "@/shared/actions/erp";
import ModalObservacionNoForm from "@/shared/components/ui/ModalObservacionNoForm";
import { useEffect, useState } from "react";
import RecepcionGroupButton from "@/shared/components/ui/RecepcionGroupButton/RecepcionGroupButton";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import useTableColumnsRecepcionCompra from "@/shared/hooks/useTableColumnsRecepcionCompra";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { useProductosEliminados } from "@/store/erp/productos/productosEliminados.store";
import ModalProductoSeries from "@/shared/components/ui/CargarSeries/ModalProductoSeries";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CustomCircularProgress from "@/shared/components/ui/Loaders/CustomCircularProgress";
import { useUiStore } from "@/store/ui";
import { AlertSeverityEnum } from "@/shared/interfaces";
import { PermissionsEnum } from "@/auth/interfaces";
import { useRecepcionMercaderia } from "@/store/erp/recepcion-mercaderia/recepcion-mercaderia-store";
import { toast } from "react-toastify";

export default function RecepcionCompraCrearPage() {
  //const { id } = useParams()
  useCheckPermissionsArray([
    PermissionsEnum.api_view_ordencompra,
    PermissionsEnum.api_change_ordencompra,
  ])

  const navigate = useNavigate()
  const location = useLocation();
  const {
    observacionSolicitante,
    observacionGeneraOrden,
    observacionRevisorOrden,
    observacionSolicitudRevision,
    solicitudIngreso,
    codigoOrdenCompra,
    id_orden_compra,
    estado_orden
  } = location.state || {}
  ///console.log('estado', estado_orden)

  //form 
  const form = useForm<SaveRecepcionCompraFormData>({
    resolver: yupResolver(newRecepcionCompraSchema),
  });

  const {
    //control,
    reset,
    handleSubmit,
    formState: { errors }
  } = form
  ///***fetch */
  const { data: dataBodegas, isLoading: isLoadingBodega } =
    useFetchBodegas({
      page_size: 600,
      nombre: TiposBodegaEnum.BODEGA_MATRIZ_QUITO
    })


  const { data: ubDestino, isLoading: isLoadingUb } = useFetchUbicaciones({
    page_size: 600,
    bodega: form.getValues().bodega,
    nombre: TipoUbicacionEnum.GENERICA
  }, !!form.watch('bodega'));
  const createIngresoInventario = useCreateIngresoProducto()
  ///*** */
  const updateOrdenCompra = useUpdateOrdenesCompra({
    enableSuccessAlert: false,
  })
  /* const {data: dataOrdenCompra} = useGetOrdenesCompra(id!)
  console.log('data',dataOrdenCompra) */

  useEffect(() => {
    if (!dataBodegas?.data?.data.length) return
    const bodegaCodigo = dataBodegas?.data?.data[0]?.codigo
    form.setValue('bodega', bodegaCodigo!)
  }, [dataBodegas])
  ///state
  const [value, setValue] = useState(1)
  const [btnRecepcionValida, setBtnRecepcionValida] = useState(false)
  const [cantidaRecibida, setCantidadRecibida] = useState(false)
  const [isLoadingProgress, setIsLoadingProgress] = useState(false)
  //const [recepcionRealizada, setRecepcionRealizada] = useState(false)

  //store
  const setConfirmDialog = useUiStore(s => s.setConfirmDialog);
  const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const setPaginationSample = useCargarSeriesProductos(s => s.setPagination)
  const paginationSample = useCargarSeriesProductos(s => s.pagination)
  const productos = useCargarSeriesProductos(s => s.productos)
  const handleAgregarUrlSerie = useCargarSeriesProductos(s => s.handleAgregarUrlSerie)
  const productosSinPendientes = useProductosEliminados(s => s.productos)

  //console.log('productosSinPendientes', productosSinPendientes)
  const paginatedDataSinPendientes = useProductosEliminados(s => s.paginatedData)
  const paginationSinPendientes = useProductosEliminados(s => s.pagination)
  const setPaginationSinPendientes = useProductosEliminados(s => s.setPagination)
  const clearSelectedItemsSinpendientes = useProductosEliminados(s => s.clearSelectedItems)

  const setAlert = useUiStore(s => s.setAlert)
  const { handleUploadFile } = useUploadFile();
  const setIsOpenModel = useRecepcionMercaderia(s => s.setIsOpenModal)

  //hook
  const {
    columnsRecepcionCompra,
    columnsRecepcionSinPendiente,
  } = useTableColumnsRecepcionCompra()


  //**verifica si todos los productos tienen cantidad_acumulada*/
  useEffect(() => {
    const productoNoRecibido = productos.some(producto => {
      const cantidad = Number(producto.cantidad)
      const cantidadAcumulada = producto.cantidad_acumulada
      const cantidadRecibida = producto.cantidad_recibida;

      return !(cantidad === cantidadAcumulada || cantidad === cantidadRecibida || cantidad === (Number(cantidadAcumulada) + Number(cantidadRecibida)));
    })

    setBtnRecepcionValida(!productoNoRecibido)

    const cantidadRecibida = productos.some(productos => productos.cantidad_recibida !== 0)
    setCantidadRecibida(cantidadRecibida)

  }, [productos])

  const handleButtonClick = (value: number) => {
    setValue(value)
  }
  //***limpia cuando el dato esta vacio */
  useEffect(() => {
    if (productos.length !== 0) return
    navigate(ROUTER_PATHS.inventario.recepcionCompraNav)
  }, [productos])

  //*onSave-Recepcion-parcial
  const onSaveParcial = () => {

    const { numero_factura, numero_guia_remision } = form.getValues()

    if (!numero_factura && !numero_guia_remision) {
      setAlert(true, 'Le sugerimos que ingreses ya sea N° de Factura o N° de Remisión.', AlertSeverityEnum.error)
      return
    }


    for (let element of productos) {
      /* if (element.contiene_serie && element.series?.length == 0)
        return toast.error(`El producto con el código ${element.producto_data?.codigo} series pendientes por cargar`) */
      if (element.contiene_serie && element.series?.length != element.cantidad_recibida)
        return toast.error(`El producto con el código ${element.producto_data?.codigo} tiene una discrepancia entre la cantidad ingresada y las series cargadas. Por favor, revisa la información y vuelve a intentarlo.`)
    }



    setConfirmDialogIsOpen(true)
    setConfirmDialog({
      cancelTextBtn: 'Cerrar',
      isOpen: true,
      title: 'Recepcion Parcial!',
      subtitle: "¿Estás seguro de realizar una recepción parcial de los productos.?",
      onClose() {
        setConfirmDialogIsOpen(false)
      },
      onConfirm: async () => {
        setConfirmDialogIsOpen(false)
        setIsLoadingProgress(true)
        const newProductoData = await handleAgregarUrlSerie(handleUploadFile)

        const cantidadproducto = newProductoData?.map((elemento) => ({
          ...elemento,
          cantidad: elemento.cantidad_recibida?.toString()
        })).filter((elemento) => Number(elemento.cantidad_recibida) > 0)

        const recepcionParcial: any = {
          ...form.getValues(),
          solicitud_ingreso: solicitudIngreso,
          orden_compra: codigoOrdenCompra,
          productos: cantidadproducto,
        }

        const ordenCompra: any = {
          id: id_orden_compra,
          data: {
            estado_orden: EstadosProcesoEnumChoice.PARCIAL
          }
        }
        //console.log('Parcial', recepcionParcial)
        //return;
        try {

          const respRecepcionParcial = await createIngresoInventario.mutateAsync(recepcionParcial)
          if (respRecepcionParcial.code !== 200 && respRecepcionParcial.code !== 202) return;
          if (estado_orden === EstadosProcesoEnumChoice.ABIERTO) {
            await updateOrdenCompra.mutateAsync(ordenCompra)
          }

          navigate(ROUTER_PATHS.inventario.recepcionCompraNav)
          reset({ bodega: undefined })
          clearSelectedItems()
          setIsOpenModel(true)


        } catch (errors) {
          console.log(errors)
        } finally {
          setIsLoadingProgress(false)
        }

      },
    })

  }
  ///onSave_Recepcion_Total
  const onSaveTotal = () => {
    const { numero_factura, numero_guia_remision } = form.getValues()

    if (!numero_factura && !numero_guia_remision) {
      setAlert(true, 'Le sugerimos que ingreses ya sea N° de Factura o N° de Remisión.', AlertSeverityEnum.error)
      return
    }

    setConfirmDialogIsOpen(true)
    setConfirmDialog({
      cancelTextBtn: 'Cerrar',
      isOpen: true,
      title: ' Recepcion Total',
      subtitle: 'Al confirmar, Todos los productos serán recibidos y la orden de compra se cerrará. Esta acción es irreversible.',
      onClose() {
        setConfirmDialogIsOpen(false)
      },
      onConfirm: async () => {
        setConfirmDialogIsOpen(false)
        setIsLoadingProgress(true)
        const newProductoData = await handleAgregarUrlSerie(handleUploadFile)
        const newDataProducto = newProductoData?.map((item) => ({
          ...item,
          cantidad: item.cantidad_recibida?.toString()
        }))
        const recepcionTotal = {
          ...form.getValues(),
          solicitud_ingreso: solicitudIngreso,
          orden_compra: codigoOrdenCompra,
          productos: newDataProducto
        } as any

        /*    console.log('Total', recepcionTotal)
           return; */
        try {
          const respRecepcionTotal = await createIngresoInventario.mutateAsync(recepcionTotal)
          if (respRecepcionTotal.code !== 200 && respRecepcionTotal.code !== 202) return;

          navigate(ROUTER_PATHS.inventario.recepcionCompraNav)

          reset({ bodega: undefined })
          clearSelectedItems()
          //setRecepcionRealizada(true)

        } catch (error) {
          console.log(errors)
        } finally {
          setIsLoadingProgress(false)
        }
      }
    })
  }


  return (
    <>
      <Typography variant="h5">{' 📦 Recepción de Mercadería Crear'}</Typography>
      <Grid container spacing={3}>
        <Grid item {...gridSize} spacing={1} container justifyContent={'flex-end'}>
          <Grid item >
            <SingleButton
              label="Regresar"
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              onClick={() => {
                navigate(ROUTER_PATHS.inventario.recepcionCompraNav)
                clearSelectedItems()
                setBtnRecepcionValida(false)
                setCantidadRecibida(false)
                setValue(1)
                clearSelectedItemsSinpendientes()

              }}
            />
          </Grid>
          <Grid item>
            {(!btnRecepcionValida && cantidaRecibida && (
              <SingleButton
                label="Recepción Parcial"
                variant="outlined"
                startIcon={<RuleRoundedIcon />}
                color={'warning'}
                onClick={handleSubmit(onSaveParcial,
                  () => { setAlert(true, "Campos Obligatorios", AlertSeverityEnum.error) }
                )}
              />
            ))}
          </Grid>
          <Grid item>
            {(btnRecepcionValida === true) && (
              <SingleButton
                label="Recepción Total"
                variant="outlined"
                startIcon={<FactCheckIcon />}
                color={'success'}
                onClick={handleSubmit(onSaveTotal,
                  () => {
                    setAlert(true, "Campos obligatorios", AlertSeverityEnum.error)
                  }
                )}
              />

            )}

          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={3}>
            <CustomTextField
              label="Número de  Factura"
              name="numero_factura"
              error={errors.numero_factura}
              helperText={errors.numero_factura?.message}
              control={form.control}
              size={gridSizeMdLg4}
              required={true}
              type="numeroFactura"
              placeholder="Ej:001-001-000123456"
            />
            <CustomTextField
              label="Guía de Remisión"
              name="numero_guia_remision"
              error={errors.numero_guia_remision}
              helperText={errors.numero_guia_remision?.message}
              control={form.control}
              size={gridSizeMdLg4}
              required={true}
              type="numeroRemision"
              placeholder="Ej: 001-001-000123456"
            />
            <CustomTextFielRead<BODEGAS>
              label={texto.bodega}
              name="bodega"
              valueKey={"nombre"}
              actualValueKey={"codigo"}
              isLoadingData={isLoadingBodega}
              control={form.control}
              defaultValue={form.getValues().bodega || ''}
              value={dataBodegas?.data.data[0]}
              size={gridSizeMdLg4}
            />
            <CustomTextFielRead<Ubicaciones>
              label={'Ubicación'}
              name="ubicacion"
              valueKey={"nombre"}
              actualValueKey={"codigo"}
              isLoadingData={isLoadingUb}
              control={form.control}
              defaultValue={form.getValues().ubicacion || ''}
              value={ubDestino?.data.data[0]}
              size={gridSizeMdLg4}
            />
            <ModalObservacionNoForm
              label="Observación del solicitante (Bodega)"
              texto={observacionSolicitante || 'N/A'}
              size={gridSizeMdLg4}
              title="Observación"
              numbertextPreview={20}
            />
            <ModalObservacionNoForm
              label="Observación Revisor solicitud "
              texto={observacionSolicitudRevision || 'N/A'}
              size={gridSizeMdLg4}
              title="Observación"
              numbertextPreview={20}
            />
            <ModalObservacionNoForm
              label="Observación Departamento de Compras "
              texto={observacionGeneraOrden || 'N/A'}
              size={gridSizeMdLg4}
              title="Observación"
              numbertextPreview={20}
            />
            <ModalObservacionNoForm
              label="Observación Revisor Orden "
              texto={observacionRevisorOrden || 'N/A'}
              size={gridSizeMdLg4}
              title="Observación"
              numbertextPreview={20}
            />

          </Grid>
        </Grid>

        <Grid item xs={12}>
          <RecepcionGroupButton
            handleButtonClick={handleButtonClick}
            activeButton={value}
            buttonSize="small"
          >
            {value === 1 && (

              <Grid item xs={12}>
                <SampleTablePagination
                  columns={columnsRecepcionCompra}
                  data={paginatedData}
                  rowCount={productos.length}
                  setPagination={setPaginationSample}
                  pagination={paginationSample}
                />
              </Grid>
            )}

            {value === 2 && (
              <Grid item xs={12}>
                <SampleTablePagination
                  columns={columnsRecepcionSinPendiente}
                  data={paginatedDataSinPendientes}
                  rowCount={productosSinPendientes.length}
                  setPagination={setPaginationSinPendientes}
                  pagination={paginationSinPendientes}
                />
              </Grid>
            )
            }

          </RecepcionGroupButton>
          <ModalProductoSeries
            generarSerie={false}///esto le comente
            seleccionarAutomatico={false}
            seleccionarManual={false}
            size={gridSizeMdLg3}
            keyCant={'cantidad_recibida'}
          />
          <CustomCircularProgress
            open={isLoadingProgress}
            message="Espere un momento"
            progressColor="inherit"
            thickness={2}
            puntoAnimado={true}
          />
        </Grid>
      </Grid>

    </>
  )

}